import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import AuthContext from "../context/AuthContext";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="#">
        elektro essmann
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#1d9538",
    },
    secondary: {
      main: "#1d9538",
    },
  },
});

export default function LoginPage() {
  const [errorM, setErrorM] = useState(false);
  const [openForgotDialog, setOpenForgotDialog] = useState(false);
  const [forgotUsername, setForgotUsername] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");
  let { loginUser } = useContext(AuthContext);

  const handleSubmit = async (event) => {
    setErrorM(!(await loginUser(event)));
  };

  const handleForgotPassword = async () => {
    try {
      const response = await fetch('/api/password-reset-email/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: forgotUsername })
      });
      const data = await response.json();
      setForgotMessage(data.text);
    } catch (error) {
      setForgotMessage("Ein Fehler ist aufgetreten.");
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" style={{ marginTop: 100 }}>
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography component="h1" variant="h5">
            Anmelden
          </Typography>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              className="textField"
              margin="normal"
              required
              fullWidth
              id="username"
              label="Benutzername"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              className="textField"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Passwort"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {errorM && (
              <Typography color="error">
                Anmeldung nicht möglich. Überprüfe das Passwort und den
                Benutzernamen.
              </Typography>
            )}
            <FormControlLabel
              control={<Checkbox value="remember" color={"primary"} />}
              label="Anmeldedaten speichern"
            />
            <Button
              className="loginButton"
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
                backgroundColor: "#1d9538",
                "&:hover": {
                  backgroundColor: "#177a2e",
                },
              }}
            >
              Anmelden
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2" onClick={() => { setOpenForgotDialog(true); setForgotMessage(""); }}>
                  Passwort vergessen?
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />

        {/* Forgot Password Dialog */}
        <Dialog open={openForgotDialog} onClose={() => setOpenForgotDialog(false)}>
          <DialogTitle>Passwort zurücksetzen</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Bitte gib deinen Benutzernamen ein. Ein neues Passwort wird an deine E-Mail (oder den Administrator) gesendet.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="forgot-username"
              label="Benutzername"
              type="text"
              fullWidth
              variant="standard"
              value={forgotUsername}
              onChange={(e) => setForgotUsername(e.target.value)}
            />
            {forgotMessage && (
              <Typography color="primary" sx={{ mt: 2 }}>
                {forgotMessage}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenForgotDialog(false)}>Abbrechen</Button>
            <Button onClick={handleForgotPassword}>Senden</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </ThemeProvider>
  );
}
